import { render, staticRenderFns } from "./PostNotFound.vue?vue&type=template&id=6c5171ac&scoped=true&"
import script from "./PostNotFound.vue?vue&type=script&lang=js&"
export * from "./PostNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5171ac",
  null
  
)

export default component.exports